import { AlertTriangle } from "lucide-react";
import { formatDate, useSubscription } from "../lib/subscription";

/**
 * Hinweis auf die automatische Konto-Löschung nach 60 Tagen ohne aktiven Zugang
 * (Abo/Test). Zeigt den verbleibenden Countdown und einen Datenschutzhinweis.
 * Rendert nichts, solange der Zugang aktiv ist oder noch keine Frist läuft.
 */
export default function DeletionCountdownNotice({
  className = "",
}: {
  className?: string;
}) {
  const { data } = useSubscription();
  const deletion = data?.deletion;

  if (!deletion || deletion.active || deletion.daysRemaining == null) {
    return null;
  }

  const days = deletion.daysRemaining;
  const dayLabel = days === 1 ? "Tag" : "Tagen";

  return (
    <div
      className={`rounded-2xl border-2 border-amber-200 bg-amber-50 px-4 py-3 ${className}`}
      data-testid="notice-deletion-countdown"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle size={18} className="text-amber-600 shrink-0 mt-0.5" />
        <div className="text-[13.5px] text-amber-900 leading-relaxed">
          <p className="font-semibold">
            {days <= 0
              ? "Dein Konto wird in Kürze gelöscht."
              : `Dein Konto wird in ${days} ${dayLabel} automatisch gelöscht.`}
          </p>
          <p className="mt-1">
            Ohne aktives Abo oder laufenden Test entfernen wir dein Konto und alle
            serverseitig gespeicherten Daten aus Datenschutzgründen
            {deletion.scheduledAt
              ? ` am ${formatDate(deletion.scheduledAt)}`
              : ""}
            . Buche ein Paket oder starte einen Test, um die Löschung zu stoppen.
          </p>
        </div>
      </div>
    </div>
  );
}
